import {Link} from 'react-router-dom'
import {FileQuestion} from 'lucide-react'
import {AppHeader} from '@/widgets/app-header'
import {Button} from '@/shared/ui'
import {cn} from '@/shared/lib'

const cardClassName = cn(
  'rounded-[20px] border border-primary/15 bg-card/80 p-6 sm:p-8',
  'backdrop-blur-[20px] transition-all duration-300',
  'shadow-(--shadow-card)',
)

export function NotFoundPage() {
  return (
    <div className="relative flex min-h-screen flex-col overflow-hidden">
      <AppHeader />
      <div className="relative flex flex-1 items-center justify-center px-4 py-8 sm:px-8 sm:py-0">
        <div className="w-full max-w-[360px] animate-in fade-in slide-in-from-bottom-3 duration-500">
          <div className={cn(cardClassName, 'flex flex-col items-center gap-4 text-center')}>
            <FileQuestion className="size-10 text-muted-foreground" strokeWidth={1.5} />
            <div>
              <h1 className="text-xl font-semibold">Страница не существует</h1>
              <p className="mt-1 text-sm text-muted-foreground">
                Запрашиваемая страница не найдена или была удалена.
              </p>
            </div>
            <Button asChild size="lg" className="w-full">
              <Link to="/">На главную</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
